module.exports =
    ARCHIVED: 'ARCHIVED'
    DELETED: 'DELETED'
    DRAFT: 'DRAFT'
    PUBLISHED: 'PUBLISHED'
